import React, { useState } from 'react';
import Autosuggest from 'react-autosuggest';
import Input from '../../../common/components/Input/Input';
import AttributeModel from '@mm/state/model/AttributeModel';
import './SingleAttributeContainingTextInput.pcss';

type Props = {
  value: string;
  onChange: (value: string) => void;
  items: AttributeModel[];
  onBlur?: () => void;
  className?: string;
  placeholder?: string;
};

const SingleAttributeContainingTextInput = (props: Props) => {
  const { placeholder, items, value, onChange, onBlur, className } = props;
  const [suggestions, setSuggestions] = useState<AttributeModel[]>([]);
  const [hasFocus, setHasFocus] = useState(false);
  const onSuggestionsFetchRequested = (value: string) => {
    setSuggestions(items.filter(i => i.name.startsWith(value)));
  };
  const wrapperClassName = `single-attribute-containing-text-input ${
    className || ''
  }`;
  return (
    <div className={wrapperClassName}>
      <Autosuggest
        inputProps={{
          value,
          placeholder,
          onFocus: () => setHasFocus(true),
          onBlur: () => {
            setHasFocus(false);
            if (onBlur) onBlur();
          },
          onChange: (e, { newValue }) => {
            if (newValue !== undefined) {
              onChange(newValue);
            }
          },
        }}
        onSuggestionSelected={(e, { suggestion }) => onChange(suggestion.name)}
        onSuggestionsFetchRequested={({ value }) =>
          onSuggestionsFetchRequested(value)
        }
        onSuggestionsClearRequested={() => setSuggestions([])}
        suggestions={suggestions}
        shouldRenderSuggestions={() => true}
        getSuggestionValue={s => undefined as any}
        renderInputComponent={inputProps => (
          <Input
            {...inputProps}
            value={
              value && !hasFocus ? `{{${inputProps.value}}}` : inputProps.value
            }
            onKeyDown={e => {
              if (e.key === 'Tab') {
                if (hasFocus && suggestions.length) {
                  e.preventDefault();
                  e.stopPropagation();

                  // Trick Autosuggest into thinking Tab is Enter.
                  e.key = 'Enter';
                  e.keyCode = 13;
                }
              }
              inputProps.onKeyDown && inputProps.onKeyDown(e);
            }}
          />
        )}
        renderSuggestion={(suggestion, { isHighlighted }) => (
          <div
            className="single-attribute-containing-text-input__suggestion"
            style={{
              background: isHighlighted ? '#b5c0f8' : 'white',
            }}
          >
            {suggestion.name}
          </div>
        )}
      />
    </div>
  );
};

export default SingleAttributeContainingTextInput;
